import React from "react";
// React Aria Toast is published under UNSTABLE_ prefixes in react-aria-components.
// Adobe's own docs at https://react-aria.adobe.com/Toast recommend exactly these
// imports — UNSTABLE here means "API may change in minor bumps," not "internal."
// This file is the only place that touches those symbols, so any future rename
// (or the eventual stabilization, see adobe/react-spectrum#8956) is a one-file edit.
import {
    Text,
    UNSTABLE_Toast as Toast,
    UNSTABLE_ToastContent as ToastContent,
    UNSTABLE_ToastQueue as ToastQueue,
    UNSTABLE_ToastRegion as ToastRegion,
} from "react-aria-components";
import { t } from "ttag";

import { Clickable } from "../Clickables";
import { Svg } from "../Svg";

import styles from "./index.module.scss";

interface FavoriteToastContent {
    title: string;
}

export const toastQueue = new ToastQueue<FavoriteToastContent>({
    maxVisibleToasts: 3,
});

/**
 * Dismiss every currently-queued toast. Exported for Storybook interaction
 * tests so each play function starts with a clean queue — the module-level
 * `toastQueue` persists across stories in a test session.
 */
export const clearToastQueue = () => {
    // Copy the array: close() mutates visibleToasts during iteration.
    for (const toast of [...toastQueue.visibleToasts]) {
        toastQueue.close(toast.key);
    }
};

export const FavoritesToastRegion = () => (
    <ToastRegion queue={toastQueue} className={styles.region}>
        {({ toast }) => (
            <Toast toast={toast} className={styles.toast}>
                <ToastContent className={styles.content}>
                    <Text slot="title" className={styles.title}>
                        {toast.content.title}
                    </Text>
                </ToastContent>
                <Clickable slot="close" className={styles.close}>
                    <Svg name="x" visuallyHiddenText={t`Dismiss`} />
                </Clickable>
            </Toast>
        )}
    </ToastRegion>
);
